module.exports = __webpack_public_path__ + "img/tarologo.ea766b2e.png";